import React, { useEffect, useState } from 'react'
import PureTitle from '../../components/PureTitle'
import Dropdown1 from 'srcReact/components/common2/Dropdown1'
import Label from 'srcReact/components/common2/Label'
import styles from './styles.module.scss'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { mixrActions } from 'srcReact/Mixr/actions'
import parentStyles from '../../../CreateUpdateMixr/styles.module.scss'
import ErrorMessage from 'srcReact/components/common2/ErrorMessage'
import PricingItem from './PricingItem'

export default function MixrPricing({ editMode, previewEditMode }) {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [valueChanged, setValueChanged] = useState(false)
  const [pricingDetails, setPricingDetails] = useState([{ amount: 0, link: '' }])
  const [atleastOnePricingErrorMessage, setAtleastOnePricingErrorMessage] = useState('')
  const [pricingDetailsWithError, setPricingDetailsWithError] = useState([])
  const [selectedPricing, setSelectedPricing] = useState({
    value: 0,
    label: t('event.create.timing.withoutFees')
  })
  const [pricingItems] = useState([
    {
      value: 0,
      label: t('event.create.timing.withoutFees')
    },
    {
      value: 1,
      label: t('event.create.timing.withFees')
    }
  ])

  const {
    mixr: {
      mixr: { fees }
    }
  } = useSelector((state) => state)

  useEffect(() => {
    if (editMode || previewEditMode) {
      if (fees && fees.length > 0) {
        setPricingDetails(JSON.parse(JSON.stringify([...fees])))
        setSelectedPricing({
          value: 1,
          label: t('event.create.timing.withFees')
        })
      } else {
        setSelectedPricing({
          value: 0,
          label: t('event.create.timing.withoutFees')
        })
      }
    }
  }, [fees])

  const handleAddAnotherLink = () => {
    setValueChanged(true)
    let valid = validatePricingDetails()
    if (valid) {
      setPricingDetails([...pricingDetails, { amount: 0, link: '' }])
    }
    setAtleastOnePricingErrorMessage('')
  }

  const validatePricingDetails = () => {
    let valid = true
    let selectedCurrency = ''
    let selectedCategories = []

    if (selectedPricing.value === 1) {
      let errors = []
      for (let i = 0; i < pricingDetails.length; i++) {
        const { amount, currency_code, category_id, category_other } = pricingDetails[i]
        if (!selectedCurrency) {
          selectedCurrency = currency_code
        }

        let errorObj = { ...pricingDetails[i] }
        if (!amount || amount <= 0) {
          valid = false
          errorObj.amountError = t('event.create.clientErrors.amountRequired')
        }

        if (currency_code === '') {
          valid = false
          errorObj.currencyError = t('event.create.clientErrors.currencyRequired')
        } else if (selectedCurrency && selectedCurrency.length > 0 && currency_code !== selectedCurrency) {
          valid = false
          errorObj.currencyError = t('event.create.clientErrors.differentCurrency')
        }
        if (category_id === -1) {
          valid = false
          errorObj.feesCategoryError = t('event.create.clientErrors.feesCategoryRequired')
        } else if (
          selectedCategories &&
          selectedCategories.length > 0 &&
          category_id &&
          selectedCategories.includes(category_id)
        ) {
          valid = false
          errorObj.feesCategoryError = t('event.create.clientErrors.duplicateCategory')
        }
        if (category_id === 8 && category_other && category_other.length === 0) {
          valid = false
          errorObj.otherCategoryError = t('event.create.clientErrors.feesCategoryRequired')
        }
        selectedCategories.push(category_id)
        errors.push(errorObj)
      }
      setPricingDetailsWithError([...errors])
    }

    return valid
  }

  const handlePricingChange = (item) => {
    setValueChanged(true)
    setSelectedPricing(item)
    setAtleastOnePricingErrorMessage('')
  }
  const handlePricingDetailChange = (pricingObj, index) => {
    const updated = pricingDetails.map((p, idx) => {
      if (index === idx) {
        pricingDetails[idx] = { ...pricingObj }
      }
      return pricingDetails[idx]
    })

    setPricingDetails([...updated])
    if (!editMode || previewEditMode) {
      const pricingType = { key: 'pricing_type', value: 'free' }
      if (updated.length > 0) {
        pricingType.value = 'with_fees'
      }
      dispatch(mixrActions.setMixrData([{ key: 'fees', value: [...updated] }, pricingType]))
    } else {
      setValueChanged(true)
    }
  }

  const removePricingDetail = (index) => {
    setValueChanged(true)
    if (pricingDetails.length > 1) {
      const updatedPricingDetails = pricingDetails.filter((i, idx) => idx !== index)
      setPricingDetails([...updatedPricingDetails])
      setAtleastOnePricingErrorMessage('')
    } else {
      setAtleastOnePricingErrorMessage(t('event.create.timing.atleastOnePricingErrorMessage'))
    }
  }
  const handleCancel = () => {
    setValueChanged(false)
    if (fees && fees.length > 0) {
      setPricingDetails(JSON.parse(JSON.stringify([...fees])))
      setSelectedPricing({
        value: 1,
        label: t('event.create.timing.withFees')
      })
    } else {
      setSelectedPricing({
        value: 0,
        label: t('event.create.timing.withoutFees')
      })
      setPricingDetails([{ amount: 0, link: '' }])
    }
  }
  return (
    <React.Fragment>
      <PureTitle title={t('event.create.timing.pricingTitle')} isRequired={false} titleCss={parentStyles.titleCss} />
      <div className={styles.pricingDropdownContainer}>
        <Label ariaLabel={t('event.create.timing.pricing')} className={styles.label}>
          {t('event.create.timing.pricing')}
        </Label>
        <Dropdown1
          value={selectedPricing}
          options={pricingItems}
          className={styles.hasPricingDropdown}
          onChange={handlePricingChange}
          isSearchable={false}
        />
      </div>
      <div className={styles.pricingContainer}>
        {selectedPricing.value === 1 &&
          pricingDetails &&
          pricingDetails.map((detail, index) => {
            return (
              <PricingItem
                editMode={editMode || previewEditMode}
                count={index + 1}
                pricingDetail={detail}
                pricingDetailWithError={pricingDetailsWithError[index]}
                // attendingType={selectedAttend}
                handleClose={() => removePricingDetail(index)}
                handleChange={handlePricingDetailChange}
              />
            )
          })}
        <ErrorMessage
          text={atleastOnePricingErrorMessage}
          className={`${parentStyles.error} ${styles.atleastOnePricingError}`}
        />
      </div>
      {selectedPricing.value === 1 && pricingDetails.length > 0 && pricingDetails.length < 5 && (
        <div className={styles.anotherFeeButtonContainer}>
          <button type='button' className={styles.anotherFeeButton} onClick={handleAddAnotherLink}>
            {t('event.create.timing.anotherFee')}
          </button>
        </div>
      )}
    </React.Fragment>
  )
}
